module.exports = __webpack_public_path__ + "media/images/recipes/bonvite_hacheevlees-deca6265fe13fa8d7bea09f5f8e37e6d.pdf";